import React, { useEffect, useState } from "react";
import * as echarts from "echarts";

export default function Traffic() {
  const [smallViewWidth, setisSmallviewWidth] = useState(false);
  useEffect(() => {
    window.innerWidth < 1192
      ? setisSmallviewWidth(true)
      : setisSmallviewWidth(false);

    window.addEventListener("resize", () => {
      window.innerWidth < 1192
        ? setisSmallviewWidth(true)
        : setisSmallviewWidth(false);
    });
  }, []);

  useEffect(() => {
    const chartDom = document.querySelector("#trafficChart");
    const trafficChart = echarts.init(chartDom);

    const option = {
      tooltip: {
        trigger: "item",
      },
      legend: {
        top: 0,
        left: "center",
        textStyle: {
          color: "#f3f3f3", // Change this to your desired color
          fontSize: 12, // Optional: change the font size
        },
      },
      series: [
        {
          name: "Access From",
          type: "pie",
          radius: ["40%", "65%"],
          center: ["50%", smallViewWidth ? "55%" : "62%"],

          avoidLabelOverlap: false,
          label: {
            show: false,
            position: "center",
          },
          emphasis: {
            label: {
              show: true,
              fontSize: "18",
              fontWeight: "bold",
              zIndex: 1,
            },
          },
          labelLine: {
            show: false,
          },
          data: [
            { value: 1048, name: "Search Engine" },
            { value: 735, name: "Direct" },
            { value: 580, name: "Email" },
            { value: 484, name: "Union Ads" },
            { value: 300, name: "Video Ads" },
          ],
        },
      ],
    };

    trafficChart.setOption(option);

    // Cleanup function to dispose of the chart on component unmount
    return () => {
      trafficChart.dispose();
    };
  }, [smallViewWidth]);

  return <div id="trafficChart" className="trafficChart"></div>;
}
